import getScenarioStore from '../selectors/getScenarioStore';
import { endSearchSession, searchSessionEnded } from '../actions/publicActions';
import {
    lazyClearLocalContentInstrumentationCache,
    lazyFlushNonRenderedItemsFromCache,
    lazyLogSessionEnd,
} from 'owa-search-service';
import { orchestrator } from 'satcheljs';
import { resetSearchStore } from '../actions/internalActions';
import getSubstrateSearchScenarioBySearchScenarioId from '../utils/getSubstrateSearchScenarioBySearchScenarioId';
import { logUsage } from 'owa-analytics';

export default orchestrator(endSearchSession, actionMessage => {
    const { scenarioId, actionSource = 'Unknown' } = actionMessage;

    const store = getScenarioStore(scenarioId);

    const searchSessionGuid = store.searchSessionGuid;
    const isLastRequestQF = store.latestTraceId === store.latestQFTraceId;
    const latestTraceId = store.latestTraceId;
    const isUsing3S = store.isUsing3S;

    // Throw if user isn't already in a search session.
    if (!searchSessionGuid) {
        throw new Error('searchSessionGuid should be set when ending a search session.');
    }

    // Dispatch action to reset store (after getting values from it).
    resetSearchStore(scenarioId);

    /**
     * If using 3S, log instrumentation to end session, and flush any
     * non-rendered events from the event cache.
     */
    if (isUsing3S) {
        const substrateSearchScenario = getSubstrateSearchScenarioBySearchScenarioId(scenarioId);

        lazyLogSessionEnd.importAndExecute(
            isLastRequestQF ? store.latestRenderedQFTraceId : latestTraceId,
            new Date(),
            substrateSearchScenario
        );

        // Flush 3S telemetry events from cache.
        lazyFlushNonRenderedItemsFromCache.importAndExecute(substrateSearchScenario);
        lazyClearLocalContentInstrumentationCache.importAndExecute();
    }

    /**
     * After common "end session" work is done, dispatch event to notify
     * consumer that search session has ended.
     */
    searchSessionEnded(searchSessionGuid, scenarioId, latestTraceId, actionSource);

    logUsage('SearchSessionEnded', [actionSource, scenarioId, searchSessionGuid]);
});
